import script from "./customer.vue?vue&type=script&setup=true&lang=js"
export * from "./customer.vue?vue&type=script&setup=true&lang=js"

import "./customer.vue?vue&type=style&index=0&id=75ade5b0&lang=less"

const __exports__ = script;

export default __exports__